export default __webpack_public_path__ + "static/media/Nav-Students.0da7e804.svg";